import React from "react";
import AxisComponent from "../../../components/IntegratedDrives/ApplicationSettings/AxisComponent";
import AddNewAxis from "../../../components/IntegratedDrives/ApplicationSettings/AddNewAxis";
import {
  addNewIntegratedDrivesAxis,
  selectIntegratedDrivesAxes,
  selectIntegratedDrivesSteps,
  setIntegratedDrivesCurrentStep
} from "../../../store/slices/integrated_drives";
import { useDispatch, useSelector } from "react-redux";
import Navigator from "../../../layouts/Navigator/Navigator";
import { updateConfiguration } from "../../../store/slices/common";

const SpecifyAndConfigure = () => {
  const dispatch = useDispatch();
  const steps = useSelector(selectIntegratedDrivesSteps);

  const axes = useSelector(selectIntegratedDrivesAxes);

  const handleAddNewAxis = () => {
    dispatch(addNewIntegratedDrivesAxis());
  };

  const continueAction = () => {
    dispatch(setIntegratedDrivesCurrentStep(steps.FINALIZE));
    dispatch(updateConfiguration());
  };
  return (
    <div className="flex flex-col space-y-4">
      {axes?.map((axis) => (
        <AxisComponent
          key={axis.id}
          axisId={axis.id}
          axisName={axis.name}
          motorType={axis.motorType}
          bundle={axis.bundle}
          collapsed={axis.collapsed}
          storedSncWidgetOutput={axis.sncWidgetOutput}
          filters={axis.configFilters}
        />
      ))}
      <AddNewAxis onClick={handleAddNewAxis} />
      <Navigator continueButtonDisabled={!axes.every((axis) => axis.bundle)} continueAction={continueAction} />
    </div>
  );
};

export default SpecifyAndConfigure;
